import React from 'react'
import PageTop from '../../common/PageTop/PageTop'
import Nav from '../Home/Nav/Nav'
import About from '../About/About'
import Vision from '../vision/Vision'
import Footer from '../../common/Footer/Footer'
import aboutimage from '../../../assets/images/15870.jpg'

const AboutPage = () => {
  return (
    <>
    <Nav/>
    <PageTop title={'Who We Are'} image={aboutimage}/>
    <About/>
    <Vision/>
    <Footer/>

    </>
  )
}

export default AboutPage